<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Dashboard
            </h2>
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-2 lg:px-4">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
<!--                            <div class="flex flex-wrap -m-4">-->
<!--                                <div class="xl:w-1/4 md:w-1/2 w-full p-4"-->
<!--                                     v-if="$page.props.selected_role?.name == 'kakpbj' || $page.props.selected_role?.name == 'adminkpbj' || $page.props.selected_role?.name == 'administrator'">-->
<!--                                    <Link-->
<!--                                        :href="-->
<!--                                        route('penyedia.user')-->
<!--                                    "-->
<!--                                        class="hover:text-sky-900"-->
<!--                                    >-->
<!--                                        <div-->
<!--                                            class="-->
<!--                                            border border-gray-200-->
<!--                                            p-6-->
<!--                                            rounded-lg-->
<!--                                        "-->
<!--                                        >-->
<!--                                            <div-->
<!--                                                class="-->
<!--                                                w-10-->
<!--                                                h-10-->
<!--                                                inline-flex-->
<!--                                                items-center-->
<!--                                                justify-center-->
<!--                                                rounded-full-->
<!--                                                bg-indigo-100-->
<!--                                                text-indigo-500-->
<!--                                                mb-4-->
<!--                                            "-->
<!--                                            >-->
<!--                                                <IconUser class="h-6 w-6"/>-->

<!--                                            </div>-->
<!--                                            <h2-->
<!--                                                class="-->
<!--                                                text-lg text-sky-600-->
<!--                                                font-bold-->
<!--                                                title-font-->
<!--                                                mb-2-->
<!--                                            "-->
<!--                                            >-->

<!--                                                Daftar User Penyedia-->

<!--                                            </h2>-->
<!--                                            <p>-->
<!--                                                User verified :-->
<!--                                                <Badge severity="success">{{ sudah_verifikasi_user }}</Badge>-->

<!--                                            </p>-->
<!--                                            <p>-->
<!--                                                User Not verified :-->
<!--                                                <Badge severity="danger">{{ belum_verifikasi_user }}</Badge>-->
<!--                                            </p>-->
<!--                                        </div>-->
<!--                                    </Link>-->
<!--                                </div>-->
<!--                                <div class="xl:w-1/4 md:w-1/2 w-full p-4"-->
<!--                                     v-if="$page.props.selected_role?.name == 'timdrm' || $page.props.selected_role?.name == 'administrator'">-->
<!--                                    <Link-->
<!--                                        :href="-->
<!--                                        route('penyedia.index')-->
<!--                                    "-->
<!--                                        class="hover:text-sky-900"-->
<!--                                    >-->
<!--                                        <div-->
<!--                                            class="-->
<!--                                            border border-gray-200-->
<!--                                            p-6-->
<!--                                            rounded-lg-->
<!--                                        "-->
<!--                                        >-->
<!--                                            <div-->
<!--                                                class="-->
<!--                                                w-10-->
<!--                                                h-10-->
<!--                                                inline-flex-->
<!--                                                items-center-->
<!--                                                justify-center-->
<!--                                                rounded-full-->
<!--                                                bg-indigo-100-->
<!--                                                text-indigo-500-->
<!--                                                mb-4-->
<!--                                            "-->
<!--                                            >-->
<!--                                                <IconPenyedia class="h-6 w-6"/>-->
<!--                                            </div>-->
<!--                                            <h2-->
<!--                                                class="-->
<!--                                                text-lg text-sky-600-->
<!--                                                font-bold-->
<!--                                                title-font-->
<!--                                                mb-2-->
<!--                                            "-->
<!--                                            >-->

<!--                                                Daftar Penyedia/Rekanan-->

<!--                                            </h2>-->
<!--                                            <p>-->
<!--                                                Status Terdaftar :-->
<!--                                                <Badge>{{ terdaftar }}</Badge>-->
<!--                                            </p>-->
<!--                                            <p>-->
<!--                                                Status Terverifikasi :-->
<!--                                                <Badge severity="success">{{ verifikasi }}</Badge>-->
<!--                                            </p>-->
<!--                                            <p>-->
<!--                                                Status Klarifikasi :-->
<!--                                                <Badge severity="warning">{{ klarifikasi }}</Badge>-->
<!--                                            </p>-->
<!--                                            <p>-->
<!--                                                Status Tunda :-->
<!--                                                <Badge severity="danger">{{ tunda }}</Badge>-->
<!--                                            </p>-->
<!--                                        </div>-->
<!--                                    </Link>-->
<!--                                </div>-->
<!--                                <div class="xl:w-1/4 md:w-1/2 w-full p-4"-->
<!--                                     v-if="$page.props.selected_role?.name == 'kakpbj' || $page.props.selected_role?.name == 'adminkpbj' || $page.props.selected_role?.name == 'administrator'">-->
<!--                                    <Link-->
<!--                                        :href="-->
<!--                                        route('penetapan.index')-->
<!--                                    "-->
<!--                                        class="hover:text-sky-900"-->
<!--                                    >-->
<!--                                        <div-->
<!--                                            class="-->
<!--                                            border border-gray-200-->
<!--                                            p-6-->
<!--                                            rounded-lg-->
<!--                                        "-->
<!--                                        >-->
<!--                                            <div-->
<!--                                                class="-->
<!--                                                w-10-->
<!--                                                h-10-->
<!--                                                inline-flex-->
<!--                                                items-center-->
<!--                                                justify-center-->
<!--                                                rounded-full-->
<!--                                                bg-indigo-100-->
<!--                                                text-indigo-500-->
<!--                                                mb-4-->
<!--                                            "-->
<!--                                            >-->
<!--                                                <IconUser class="h-6 w-6"/>-->

<!--                                            </div>-->
<!--                                            <h2-->
<!--                                                class="-->
<!--                                                text-lg text-sky-600-->
<!--                                                font-bold-->
<!--                                                title-font-->
<!--                                                mb-2-->
<!--                                            "-->
<!--                                            >-->

<!--                                                Daftar Penetapan PPK,POKJA dan TIM DRM-->

<!--                                            </h2>-->
<!--                                        </div>-->
<!--                                    </Link>-->
<!--                                </div>-->

<!--                                <div class="xl:w-1/4 md:w-1/2 w-full p-4"-->
<!--                                     v-if="$page.props.selected_role?.name == 'timdrm' || $page.props.selected_role?.name == 'administrator'">-->
<!--                                    <Link-->
<!--                                        :href="-->
<!--                                        route('penyedia.daftarRekananMampu')-->
<!--                                    "-->
<!--                                        class="hover:text-sky-900"-->
<!--                                    >-->
<!--                                        <div-->
<!--                                            class="-->
<!--                                            border border-gray-200-->
<!--                                            p-6-->
<!--                                            rounded-lg-->
<!--                                        "-->
<!--                                        >-->
<!--                                            <div-->
<!--                                                class="-->
<!--                                                w-10-->
<!--                                                h-10-->
<!--                                                inline-flex-->
<!--                                                items-center-->
<!--                                                justify-center-->
<!--                                                rounded-full-->
<!--                                                bg-indigo-100-->
<!--                                                text-indigo-500-->
<!--                                                mb-4-->
<!--                                            "-->
<!--                                            >-->
<!--                                                <IconPenyedia class="h-6 w-6"/>-->
<!--                                            </div>-->
<!--                                            <h2-->
<!--                                                class="-->
<!--                                                text-lg text-sky-600-->
<!--                                                font-bold-->
<!--                                                title-font-->
<!--                                                mb-2-->
<!--                                            "-->
<!--                                            >-->

<!--                                                D R M-->

<!--                                            </h2>-->
<!--                                            <p class="leading-relaxed text-base">-->
<!--                                                Daftar Rekanan Mampu-->
<!--                                            </p>-->
<!--                                        </div>-->
<!--                                    </Link>-->
<!--                                </div>-->


<!--                            </div>-->

                            <div class="bg-white ">
                                <div class="mx-auto max-w-7xl px-6 lg:px-8">
<!--                                    <div class="mx-auto max-w-2xl sm:text-center">-->
<!--                                        <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"> {{ $page.props.setting.appName }}</h2>-->
<!--                                        <p class="mt-6 text-lg leading-8 text-gray-600">Sistem Pengadaan Barang dan Jasa Universitas Diponegoro</p>-->
<!--                                    </div>-->

<!--                                    menu -->
                                    <div class="grid grid-cols-2 gap-2 lg:mt-10 auto-cols-min">

                                        <div v-if="$page.props.selected_role?.name == 'kakpbj' || $page.props.selected_role?.name == 'adminkpbj' || $page.props.selected_role?.name == 'administrator'" class="mx-auto mt-2 max-w-xl min-h-full rounded-3xl ring-1 ring-gray-200 sm:mt-none lg:mx-0 lg:flex lg:max-w-2xl">
                                            <div class="p-1 sm:p-10 lg:flex-auto">
                                                <h3 class="text-2xl font-bold tracking-tight text-gray-900">User Penyedia</h3>
                                                <div class="mt-none flex items-center gap-x-4">
                                                    <h4 class="flex-none text-sm py-4 font-semibold leading-6 text-indigo-600">Notifikasi</h4>
                                                    <div class="h-px flex-auto bg-gray-100"></div>
                                                </div>
                                                <div class="bg-white" >
                                                    <div class="mx-auto max-w-7xl px-none lg:px-none">
                                                        <dl class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-2">
                                                            <div class="mx-auto flex max-w-xs flex-col gap-y-4 ">
                                                                <dt class="text-base text-gray-600">Belum Diverifikasi</dt>
                                                                <dd class=" animate-bounce order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-red-500 border-4 border-red-300 rounded-3xl border-dashed">{{ belum_verifikasi_user }}</dd>
                                                            </div>
                                                            <div class="mx-auto flex max-w-xs flex-col gap-y-4">
                                                                <dt class="text-base text-gray-600">Sudah Diverifikasi</dt>
                                                                <dd class="order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-green-500 border-4 border-green-300 rounded-3xl border-dashed">{{ sudah_verifikasi_user }}</dd>
                                                            </div>

                                                        </dl>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="-mt-2 p-2 lg:mt-0 lg:w-1/2 lg:max-w-fit lg:flex-shrink-0">
                                                <div class="rounded-2xl bg-gray-50 py-2 text-center ring-1 ring-inset min-h-full ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-2">
                                                    <div class="mx-auto max-w-xs px-8">
                                                        <p class="text-base font-semibold text-gray-600">Total User Penyedia</p>
                                                        <p class="mt-6 flex items-baseline justify-center gap-x-2">
                                                            <span class="text-5xl font-bold tracking-tight text-gray-900">{{ total_user }}</span>
                                                            <span class="text-sm font-semibold leading-6 tracking-wide text-gray-600">Perusahaan</span>
                                                        </p>
                                                        <a :href="route('penyedia.user')" class="mt-10 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Lihat Daftar User</a>
                                                        <p class="mt-6 text-xs text-gray-600">User yang terhitung adalah user yang telah melakukan pendaftaran dan sudah menerima email verifikasi</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="$page.props.selected_role?.name == 'timdrm' || $page.props.selected_role?.name == 'administrator'" class="mx-auto mt-2 max-w-2xl min-h-full rounded-3xl ring-1 ring-gray-200 sm:mt-none lg:mx-0 lg:flex lg:max-w-2xl">
                                            <div class="p-2 sm:p-10 lg:flex-auto">
                                                <h3 class="text-2xl font-bold tracking-tight text-gray-900">Penyedia</h3>
                                                <div class="mt-none flex items-center gap-x-4">
                                                    <h4 class="flex-none text-sm py-4 font-semibold leading-6 text-indigo-600">Notifikasi</h4>
                                                    <div class="h-px flex-auto bg-gray-100"></div>
                                                </div>
                                                <div class="bg-white" >
                                                    <div class="mx-auto max-w-7xl px-none lg:px-none">
                                                        <dl class="grid grid-cols-2 gap-x-8 gap-y-4 text-center lg:grid-cols-2">
                                                            <div class="mx-auto flex max-w-2xl flex-col gap-y-4 ">
                                                                <dt class="text-sm font-bold text-gray-600">Belum Terverifikasi</dt>
                                                                <dd class="animate-bounce order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-red-500 border-4 border-red-300 rounded-3xl border-dashed">{{ terdaftar }}</dd>
                                                            </div>
                                                            <div class="mx-auto flex max-w-auto flex-col gap-y-4">
                                                                <dt class="text-sm font-bold text-gray-600">Penyedia Terverifikasi</dt>
                                                                <dd class="order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-green-500 border-4 border-green-300 rounded-3xl border-dashed">{{ verifikasi }}</dd>
                                                            </div>
                                                            <div class="mx-auto flex max-w-auto flex-col gap-y-4">
                                                                <dt class="text-sm font-bold text-gray-600">Diundang Klarifikasi</dt>
                                                                <dd class="order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-yellow-500 border-4 border-yellow-300 rounded-3xl border-dashed">{{ klarifikasi }}</dd>
                                                            </div>
                                                            <div class="mx-auto flex max-w-auto flex-col gap-y-4">
                                                                <dt class="text-sm font-bold text-gray-600">Penyedia Ditunda</dt>
                                                                <dd class="order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-slate-500 border-4 border-slate-300 rounded-3xl border-dashed">{{ tunda }}</dd>
                                                            </div>
                                                        </dl>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="-mt-2 p-2 lg:mt-0 lg:w-1/2 lg:max-w-xs lg:flex-shrink-0 ">
                                                <div class="rounded-2xl bg-gray-50 py-2 text-center ring-1 ring-inset min-h-full ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-2">
                                                    <div class="mx-auto max-w-xs px-8">
                                                        <p class="text-base font-semibold text-gray-600">Total Penyedia</p>
                                                        <p class="mt-6 flex items-baseline justify-center gap-x-2">
                                                            <span class="text-5xl font-bold tracking-tight text-gray-900">{{ total_penyedia }}</span>
                                                            <span class="text-sm font-semibold leading-6 tracking-wide text-gray-600">Perusahaan</span>
                                                        </p>
                                                        <a :href="route('penyedia.index')" class="mt-10 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Lihat Daftar Penyedia</a>
                                                        <p class="mt-6 text-xs leading-5 text-gray-600">Penyedia yang terhitung adalah penyedia yang sudah melengkapi data perusahaan</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div  v-if="$page.props.selected_role?.name == 'kakpbj' || $page.props.selected_role?.name == 'adminkpbj' || $page.props.selected_role?.name == 'administrator'" class="mx-auto mt-2 max-w-xl min-h-full rounded-3xl ring-1 ring-gray-200 sm:mt-none lg:mx-0 lg:flex lg:max-w-2xl">
                                            <div class="p-1 sm:p-10 lg:flex-auto">
                                                <h3 class="text-2xl font-bold tracking-tight text-gray-900">Rekanan Mampu </h3>
                                                <div class="mt-none flex items-center gap-x-4">
                                                    <h4 class="flex-none text-sm py-4 font-semibold leading-6 text-indigo-600">Notifikasi</h4>
                                                    <div class="h-px flex-auto bg-gray-100"></div>
                                                </div>
                                                <div class="bg-white" >
                                                    <div class="mx-auto max-w-7xl px-none lg:px-none">
                                                        <dl class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-2">
                                                            <div class="mx-auto flex max-w-xs flex-col gap-y-4">
                                                                <dt class="text-base text-gray-600">SK Aktif</dt>
                                                                <dd class="order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-green-500 border-4 border-green-300 rounded-3xl border-dashed">{{ drm }}</dd>
                                                            </div>
                                                            <div class="mx-auto flex max-w-xs flex-col gap-y-4 ">
                                                                <dt class="text-base text-gray-600">SK Tidak Aktif</dt>
                                                                <dd class="order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-red-500 border-4 border-red-300 rounded-3xl border-dashed">{{ drm_tidak_aktif }}</dd>
                                                            </div>

                                                        </dl>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="-mt-2 p-2 lg:mt-0 lg:w-1/2 lg:max-w-fit lg:flex-shrink-0">
                                                <div class="rounded-2xl bg-gray-50 py-2 text-center ring-1 ring-inset min-h-full ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-2">
                                                    <div class="mx-auto max-w-xs px-8">
                                                        <p class="text-base font-semibold text-gray-600">Total Rekanan Mampu</p>
                                                        <p class="mt-6 flex items-baseline justify-center gap-x-2">
                                                            <span class="text-5xl font-bold tracking-tight text-gray-900">{{ detail_rekanan_mampu }}</span>
                                                            <span class="text-sm font-semibold leading-6 tracking-wide text-gray-600">Perusahaan</span>
                                                        </p>
                                                        <a :href="route('penyedia.daftarRekananMampu')" class="mt-10 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Lihat Daftar Rekanan Mampu</a>
                                                        <p class="mt-6 text-xs text-gray-600">Penyedia yang masuk dalam daftar rekanan mampu yang telah ditetapkan</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="$page.props.selected_role?.name == 'kakpbj' || $page.props.selected_role?.name == 'adminkpbj' || $page.props.selected_role?.name == 'administrator'" class="mx-auto mt-2 max-w-xl min-h-full rounded-3xl ring-1 ring-gray-200 sm:mt-none lg:mx-0 lg:flex lg:max-w-2xl">
                                            <div class="p-1 sm:p-10 lg:flex-auto">
                                                <h3 class="text-2xl font-bold tracking-tight text-gray-900">Penetapan</h3>
                                                <div class="mt-none flex items-center gap-x-4">
                                                    <h4 class="flex-none text-sm py-4 font-semibold leading-6 text-indigo-600">Jenis Role</h4>
                                                    <div class="h-px flex-auto bg-gray-100"></div>
                                                </div>
                                                <div class="bg-white" >
                                                    <div class="mx-auto max-w-7xl px-none lg:px-none">
                                                        <dl class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-2">
                                                            <div class="mx-auto flex max-w-xs flex-col gap-y-4">
                                                                <dd class="order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-slate-500 border-4 border-slate-300 rounded-3xl border-dashed">PPK</dd>
                                                            </div>
                                                            <div class="mx-auto flex max-w-xs flex-col gap-y-4">
                                                                <dd class="order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-slate-500 border-4 border-slate-300 rounded-3xl border-dashed">POKJA</dd>
                                                            </div>
                                                            <div class="mx-auto flex max-w-xs flex-col gap-y-4 ">
                                                                <dd class="order-first text-3xl font-semibold tracking-tight text-white sm:text-3xl bg-clip-border p-1 bg-slate-500 border-4 border-slate-300 rounded-3xl border-dashed">TIM DRM</dd>
                                                            </div>

                                                        </dl>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="-mt-2 p-2 lg:mt-0 lg:w-1/2 lg:max-w-fit lg:flex-shrink-0">
                                                <div class="rounded-2xl bg-gray-50 py-2 text-center ring-1 ring-inset min-h-full ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-2">
                                                    <div class="mx-auto max-w-xs px-8">
                                                        <p class="text-base font-semibold text-gray-600">Daftar Penetapan PPK,POKJA dan TIM DRM</p>
                                                        <a :href="route('penetapan.index')" class="mt-10 block w-full rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Lihat Daftar Penetapan</a>
                                                        <p class="mt-6 text-xs text-gray-600">Penetapan pegawai menjadi PPK, POKJA dan TIM DRM oleh KPBJ</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


<!--                                    end menu-->
                                </div>
                            </div>


                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from "vue";

import AppLayout from "@/Layouts/AppLayout";
import IconPenyedia from "@/Icons/Penyedia";
import IconUser from "@/Icons/User";
import Badge from "primevue/badge";

import IconAdd from "@/Icons/Add";
import {Link} from "@inertiajs/inertia-vue3";


export default defineComponent({
    components: {
        AppLayout,
        IconPenyedia,
        IconUser,
        Badge,
        IconAdd,
        Link,
    },
    data() {
        return {
            belum_verifikasi_user: null,
            sudah_verifikasi_user: null,
            terdaftar: null,
            klarifikasi: null,
            verifikasi: null,
            tunda: null,
            total_penyedia: null,
            total_user: null,
            drm : null,
            drm_tidak_aktif: null,
            detail_rekanan_mampu: null,
        };
    },
    methods: {
        async getNotifikasi() {
            const {data} = await axios.get(
                route("penyedia.notifikasi")
            );
            this.belum_verifikasi_user = data.belum_verifikasi_user;
            this.sudah_verifikasi_user = data.sudah_verifikasi_user;
            this.terdaftar = data.terdaftar;
            this.klarifikasi = data.klarifikasi;
            this.verifikasi = data.verifikasi;
            this.tunda = data.tunda;
            //total dari penjumlahan
            this.total_penyedia = data.terdaftar + data.klarifikasi + data.verifikasi + data.tunda;
            this.total_user = data.belum_verifikasi_user + data.sudah_verifikasi_user;
            this.drm = data.drm;
            this.drm_tidak_aktif = data.drm_tidak_aktif;
            this.detail_rekanan_mampu = data.detail_rekanan_mampu;


        },
    },
    mounted() {
        console.log("Page props : ", this.$page.props);
        this.getNotifikasi();
    },



});

</script>

<script setup lang="ts">
</script>
